module.exports = {"id":"215107","name":"Héctor Villalba","rating":"76","photo":"./data/images/photos/0/215107.png","club":{"name":"Atlanta United FC","logo":"./data/images/clubs/AtlantaUnitedFC.png"},"positions":["MD","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HectorVillalba0.json
// module id = 1713
// module chunks = 0